// components/ErrorBoundary.jsx
import React from 'react';

/**
 * Atrapa errores de render en el subárbol que envuelve y muestra un fallback
 * en vez de dejar que React desmonte toda la app (React tumba el árbol entero
 * en cualquier throw durante render si no hay un boundary — era el caso hasta
 * ahora, cero ErrorBoundary en toda la app).
 *
 * Deliberadamente sin dependencias de contexto/servicios/CSS externo: si algo
 * de eso está roto, es justamente cuando este componente tiene que poder
 * renderizar igual.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught a render error:', {
      error,
      componentStack: info?.componentStack,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            textAlign: 'center',
            fontFamily: 'sans-serif',
            color: '#e5e7eb',
            backgroundColor: '#0b0b0f',
          }}
        >
          <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
            Something went wrong
          </h1>
          <p style={{ color: '#9ca3af', marginBottom: '1.5rem' }}>
            Please try reloading the page. If the problem persists, contact support.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '0.6rem 1.2rem',
              borderRadius: '0.5rem',
              border: 'none',
              backgroundColor: '#7c3aed',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '1rem',
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
